
import { FeatureComparison } from "@/components/ui/feature-comparison";
import { motion } from "framer-motion";

export const DevelopmentComparisonSection = () => {
  return (
    <motion.section
      className="bg-gradient-to-br from-black via-brand-charcoal to-black"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 1 }}
    >
      <div className="max-w-6xl mx-auto px-4">
        <FeatureComparison 
          title="AI-Augmented vs Traditional Development"
          description="See the difference between traditional software development and our AI-augmented approach. Our process delivers enterprise-grade solutions 70% faster with higher code quality."
          beforeImage="https://images.unsplash.com/photo-1498050108023-c5249f4df085"
          beforeLabel="Traditional Development"
          afterImage="https://images.unsplash.com/photo-1487058792275-0ad4aaf24ca7" 
          afterLabel="AI-Augmented Development"
          badgeText="70% Faster"
        />
      </div>
    </motion.section>
  );
};
